import { getErrorMessage } from "../errors/errorMessages";

// Prefer a real per-request dynamic policy (the server sends one when it
// knows the specific rule that applied); fall back to the errorCode's own
// static default only when no dynamic policy is available at all (e.g. a
// network-level failure with no backend response). Historically shared by
// both the text and image pipelines, which had each reimplemented this same
// "dynamic-first, static-fallback" pattern independently — the image
// pipeline no longer calls this at all as of the presentationKey-based
// contract (config/imageProviderErrorPresentation.js) it moved to; this is
// now used only by the text battle pipeline (hooks/useBattleRequest.js).
export function resolveRulesPath(policy, errorCode) {
  return policy?.rulesPath ?? getErrorMessage(errorCode)?.rulesPath ?? null;
}
